import React, { createContext, useState, useContext, useEffect } from 'react';
import { getConfig } from '../config/appConfig';
import { resolvePaddleClientKey } from '../config/paddleConfig';
import paddleService from '../services/paddleService';

const PaddleContext = createContext();

export const PaddleProvider = ({ children }) => {
  const [paddle, setPaddle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const initializePaddle = async () => {
      try {
        if (typeof window === 'undefined') {
          setLoading(false);
          return;
        }

        // ***** Code Start BH30072026_1245 - Delegate init so checkout.completed is registered
        // Calling Paddle.Initialize() here claimed __candorPaddleInitialized before
        // paddleService could attach its eventCallback. Paddle.js v2 only honours one
        // Initialize, so checkout.completed was never handled: a paid checkout stayed on
        // Paddle's own success overlay, never redirected to /success, and
        // verify-transaction never ran — leaving the subscriptions table untouched.
        // Validate the key here (to surface config errors in the UI), then let
        // paddleService be the single initializer.
        try {
          resolvePaddleClientKey(getConfig('paddle.clientKey'));
        } catch (keyErr) {
          setError(keyErr.message || String(keyErr));
          setLoading(false);
          return;
        }

        const paddleInstance = await paddleService.initializePaddle();
        if (!paddleInstance) {
          setError('Paddle.js failed to initialize');
          setLoading(false);
          return;
        }
        setPaddle(paddleInstance);
        // ***** Code End BH30072026_1245
      } catch (err) {
        setError(err && err.message ? err.message : String(err));
      } finally {
        setLoading(false);
      }
    };

    initializePaddle();
  }, []);

  const value = {
    paddle,
    loading,
    error,
  };

  return (
    <PaddleContext.Provider value={value}>
      {children}
    </PaddleContext.Provider>
  );
};

export const usePaddle = () => {
  const context = useContext(PaddleContext);
  if (context === undefined) {
    throw new Error('usePaddle must be used within a PaddleProvider');
  }
  return context;
};
